import GenerateSingularOrPlural from './generateSingularOrPlural.utility';

class TrialSingularOrPlural extends GenerateSingularOrPlural {
  singularWord = 'Trial';

  pluralWord = 'Trials';
}

export default TrialSingularOrPlural;
